import React, { FC } from 'react';

import {
	BUTTON_TYPES,
	EvButton,
	EvIcon,
	LinkIcon,
	OpenNewTabIcon
} from '@evinced-private/ui-common';

import {
	COPY_ISSUE_LINK_DAID,
	OPEN_IN_NEW_TAB_DAID
} from 'data-automation-ids/data-automation-ids';
import { CopyToClipboard } from 'src/common/components/copy-to-clipboard/CopyToClipboard';

import './ActionButtons.scss';

const OPEN_IN_NEW_TAB_LABEL = 'Open in a New Tab';

interface IActionButtonsProps {
	textToCopy: string;
	openNewTab: () => void;
}

export const ActionButtons: FC<IActionButtonsProps> = ({ textToCopy, openNewTab }) => {
	return (
		<>
			<CopyToClipboard
				renderJustIcon
				renderTooltip
				textToCopy={textToCopy}
				className="mobile-copy-link-button"
				iconTitle="Copy Issue link"
				icon={LinkIcon}
				dataAutomationId={COPY_ISSUE_LINK_DAID}
			/>
			<EvButton
				type={BUTTON_TYPES.ICON}
				ariaLabel={OPEN_IN_NEW_TAB_LABEL}
				onClick={openNewTab}
				dataAutomationId={OPEN_IN_NEW_TAB_DAID}
				customTooltip={{ renderTooltip: true }}
			>
				<EvIcon icon={OpenNewTabIcon} />
			</EvButton>
		</>
	);
};
